import { untilComplete } from "@pjs/observables";
import { authorisedDevices } from "../authorised-devices/consts/AuthorisedDevices.const";
import { revokeDeviceAccess } from "../authorised-devices/functions/RevokeDeviceAccess.function";
import { AuthorisedDevicesState } from "../authorised-devices/enums/AuthorisedDevicesState";
import { AuthorisedDeviceRevokingState } from "../authorised-devices/enums/AuthorisedDeviceRevokingState";

export const revokeAuthorisedDeviceAccess = (tokenId: string): void => {
    const document = authorisedDevices.getDocument();
    const deviceNode = document.model.devices.select({ tokenId: tokenId });
    const deviceModel = deviceNode.get();
    if (deviceModel === null) {
        return;
    }

    deviceNode.state.update({
        descriptor: AuthorisedDeviceRevokingState.InProgress
    });

    revokeDeviceAccess(tokenId)
        .pipe(untilComplete(document.changeStream))
        .subscribe({
            error: () => {
                deviceNode.state.update({
                    descriptor: AuthorisedDeviceRevokingState.Default
                });

                document.model.state.update({
                    descriptor: AuthorisedDevicesState.RevokeError,
                    payload: {
                        activeDeviceName: deviceModel.deviceName
                    }
                });
            },
            next: () => {
                document.model.devices.remove({
                    tokenId: deviceModel.tokenId
                });

                document.model.state.update({
                    descriptor: AuthorisedDevicesState.RevokeSuccess,
                    payload: {
                        activeDeviceName: deviceModel.deviceName
                    }
                });
            }
        });
};
